import { LegalLayout } from "@/components/uc/LegalLayout";
import { Crown, Cable, Rocket } from "lucide-react";

const STEPS = [
  {
    icon: Crown, n: "01", title: "Claim Your Command",
    points: [
      "Name your Command Center on first login — this brands your entire OS.",
      "Open each of the 10 Venture Cockpit slots and load real values: name, worth, mission, accounts, website.",
      "Set your Liquidity Floor and Dead Man's Switch beneficiary in Settings — sovereignty includes succession.",
    ],
  },
  {
    icon: Cable, n: "02", title: "Wire the Gateways",
    points: [
      "Settings → Connectivity Hub: connect Business Gmail with a Google App Password, then fire 'Send Test Email'.",
      "Command Wallet: add a payment method, and when ready, use 'Go Live' with your own Stripe live keys.",
      "Per venture: add Ghost/LinkedIn publisher credentials so approved drafts publish for real. Optional: Twilio SMS + Pinecone memory keys.",
    ],
  },
  {
    icon: Rocket, n: "03", title: "Ignite the Loop",
    points: [
      "Hit 'Run Sweep' — all 7 agents deploy, Scout finds are auto-built into finished drafts, and the sourcing pass seals fresh grants/forms/news into your vault.",
      "Work the Action Hub: one-click execute what you approve. Financial items ask for your card + signature. Everything executed is sealed, encrypted, and signed in the vault.",
      "Scale: stage a '7-Day Campaign' from the Drafting Table, run code and browser missions from the Execution Console, and let Auto-Pilot handle the drumbeat.",
    ],
  },
];

export default function Handbook() {
  return (
    <LegalLayout eyebrow="ONBOARDING PACKAGE" title="Commander's Handbook" testId="handbook-page">
      <p className="text-lg text-white/80 font-serif-display">Empire Initialization — three moves from empty slots to a self-driving command.</p>
      <div className="space-y-6" data-testid="handbook-steps">
        {STEPS.map(({ icon: Icon, n, title, points }) => (
          <div key={n} className="border border-white/10 bg-white/[0.02] p-6 flex gap-5">
            <div className="shrink-0">
              <div className="w-12 h-12 border border-amber-500/40 bg-amber-500/5 flex items-center justify-center">
                <Icon size={18} className="text-amber-400"/>
              </div>
              <div className="font-mono-uc text-[10px] text-amber-400/70 tracking-widest text-center mt-2">{n}</div>
            </div>
            <div>
              <h2 className="font-serif-display text-2xl text-white mb-3">{title}</h2>
              <ul className="space-y-2">
                {points.map((p, i) => (
                  <li key={i} className="flex gap-2 text-white/65 text-sm leading-relaxed">
                    <span className="text-amber-400 mt-0.5">▸</span>{p}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
      <p className="text-white/50 text-sm">Stuck at any step? Open the <span className="text-amber-400">Umbrella Directorate</span> channel in the bottom-right corner of your dashboard — it commands knowledge of every button in this OS.</p>
    </LegalLayout>
  );
}
